module.exports = __webpack_public_path__ + "img/20.68bd223c.jpg";